import { createDecorator } from '../../../../../platform/instantiation/common/instantiation.js';
const ITerminalLinkProviderService = ( createDecorator('terminalLinkProviderService'));
export { ITerminalLinkProviderService };
